export default __webpack_public_path__ + "static/media/arrow_right.085b7653.svg";